import {Component} from '@angular/core';
import { UserGroupFormComponent, FormComponent } from '@spartacus/organization/administration/components';
import {map, tap} from 'rxjs/operators';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsComponent } from '@spartacus/storefront';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-user-group-form',
    templateUrl: './efa-user-group-form.component.html',
    imports: [FormComponent, FormsModule, ReactiveFormsModule, FormErrorsComponent, NgSelectComponent, AsyncPipe, TranslatePipe]
})
export class EfaUserGroupFormComponent extends UserGroupFormComponent {

  ngOnInit(): void {
    super.ngOnInit();
    this.units$ = this.units$.pipe(
      map((units) => units?.length > 0 ? units.slice(0, 1) : units),
      tap((units) => {
        this.form?.get('orgUnit.uid')?.setValue(units[0]?.id);
      }));
  }

  createUidWithNameAndUnit(name: AbstractControl, code: AbstractControl, unit: AbstractControl): void {
    if (!code.value) {
      const codeFromName = name.value.replace(/\s+/g, '-').toLowerCase();
      code.patchValue(unit.value.uid + '_' +  codeFromName);
    }
  }
}
